import { Table } from "../../../../models/table";
import { CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { handleApiErrors } from "../../../../services/errorHandling";
import { useErrorBoundary } from "react-error-boundary";
import { useAddCustomTableOptionMutation, useEditCustomTableOptionByIdMutation, useGetCustomTableOptionsQuery } from "../../../../redux/api/custom-tables.api";
import { CustomTableItem } from "../../../../models/custom-table-item";


interface CustomTableOptionsProps{
  customTable: Table,
  returnBack: () => void,
}

function CustomTableOptions({customTable, returnBack}: CustomTableOptionsProps) {

  const { showBoundary } = useErrorBoundary();

  const { 
    data: customTableOptions, 
    isLoading: isFetchingCustomTableOptions
  } = useGetCustomTableOptionsQuery(customTable.id);

  const [editCustomTableOption] = useEditCustomTableOptionByIdMutation();
  const [addCustomTableOption] = useAddCustomTableOptionMutation();

  const [action, setAction] = useState<string>("browse")
  const [customTableOptionsCopy, setCustomTableOptionsCopy] = useState<CustomTableItem[]>();



  useEffect(()=>{

    if(customTableOptions){
      setCustomTableOptionsCopy(customTableOptions);
    }

  },[customTableOptions]);


  /**
   * save the edited system option in the state
   * @param event 
   * @param tableChanged 
   */
  function apdateState(event: React.ChangeEvent<HTMLInputElement>, tableChanged: CustomTableItem): void{

    const customTableOptionsToUpdate = customTableOptionsCopy?.map(
      table => table.id === tableChanged.id ? { ...tableChanged, name: event.target.value } : table
    );

    setCustomTableOptionsCopy(customTableOptionsToUpdate);
  }


  /**
   * save the edited system table option in db and store
   * @param option 
   */
  async function saveInput(option: CustomTableItem){
    try {
      await editCustomTableOption(option);
    } 
    
    catch (error) {
      handleApiErrors(error, showBoundary);
    }
  }
  

  /**
   * add a new option to a system table
   */
  async function addNewCustomTableOption(): Promise<undefined>{
    try {
      const optionIndex: number = (customTableOptionsCopy?.length ?? 0) + 1;
      await addCustomTableOption({customTableId: customTable.id, optionIndex});
    } 
    
    catch (error) {
      handleApiErrors(error, showBoundary);
    }
    
  }

  return (
    <>
      { (isFetchingCustomTableOptions) && <CircularProgress color="inherit" sx={{ display: "block", margin: "auto", padding: 4 }} />}
      
      {!isFetchingCustomTableOptions && customTableOptionsCopy && (
        <>
          <Typography variant="h3" className="title">
            טבלת {customTable.name}
          </Typography>

          <div className="table-container">
            <table>
              <tbody>
                {
                  customTableOptionsCopy.map((option, index) => (
                    <tr key={index}>
                        <td>{option.index}.</td>
                        <td className="expand" >
                          {action === 'browse' && option.name}
                          {action === 'edit' && <input value={option.name || ""} onChange={(e) => { apdateState(e, option) }} onBlur={() => { saveInput(option) }} />}
                        </td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>
          <div className="buttons">
            <button onClick={returnBack}>חזור</button>
            {action === 'browse' ? <button onClick={() => { setAction('edit') }}>עריכה</button> : <button onClick={() => { setAction('browse') }}>סיום עריכה</button>}
            <button onClick={addNewCustomTableOption}>הוספת שורה</button>
          </div>
        </>
        
      )}
    </>
      
  );
}

export default CustomTableOptions